module.exports = __webpack_public_path__ + "img/jieshao.18677a5d.jpg";